module.exports = __webpack_public_path__ + "static/img/partner_6.e7672b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_6.png
// module id = Zdgr
// module chunks = 0